export default "__VITE_ASSET__BdLgwxjD__"